import React, { FC } from 'react'

import { FiltersSharedProps } from './Filters.types'
import { ToggleBasedFilter } from './FiltersVariations/Toggle'

interface OnlyActiveFilterProps extends FiltersSharedProps {
  initialValue?: boolean
  onChange: (value?: boolean) => void
}

export const OnlyActiveFilter: FC<OnlyActiveFilterProps> = props => (
  <ToggleBasedFilter title="Only Active" {...props} />
)
